<template>
    <div
        class="field-wysiwyg field-wrap"
        :class="{
            'field-wysiwyg--has-focus': hasFocus,
            'field-wysiwyg--is-invalid': simpleFieldGet.length === 0 && required,
            'field-wysiwyg--reduced': slim
        }"
    >
        <label v-if="label || required" class="field-wyiwyg__label"
            >{{ label }}<span v-if="required" class="req">&nbsp;*</span></label
        >
        <editor v-model="simpleFieldModel" :init="tinyMceConfiguration"></editor>
    </div>
</template>

<script>
/* core (needed, even not used, because otherwise tiny-mce uses the cloud version) */
import tinymce from 'tinymce/tinymce';
tinymce; // prevent unused compile error
import 'tinymce/themes/modern/theme';
/* tinymce-vue */
import Editor from '@tinymce/tinymce-vue';

import { toArray } from '@/helpers/utils';
import { mapActions, mapGetters } from 'vuex';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    data() {
        return {
            hasFocus: false,
            instance: null,
            tinyMceConfiguration: {
                branding: false,
                skin_url: '/assets/tinymce/skins/tecpage',
                language_url: '/assets/tinymce/langs/de.js',
                content_css: '/assets/tinymce/skins/tecpage/custom.css',
                language: 'de',
                autoresize_bottom_margin: 0,
                autoresize_overflow_padding: 0,
                /* plugins (this way, we can place the plugins anywhere and all assets are found) */
                external_plugins: {
                    autoresize: '/assets/tinymce/plugins/autoresize/plugin.min.js',
                    link: '/assets/tinymce/plugins/link/plugin.min.js',
                    lists: '/assets/tinymce/plugins/lists/plugin.min.js',
                    paste: '/assets/tinymce/plugins/paste/plugin.min.js'
                },
                paste_as_text: true,
                menubar: false,
                statusbar: false,
                forced_root_block: this.slim === true ? false : 'p',
                toolbar: (this.slim === true ? '' : 'bold bullist numlist link ') + 'textpicker',
                invalid_elements: this.slim === true ? 'p' : '',
                relative_urls: false,
                convert_urls: false,
                remove_script_host: false,
                setup: (editor) => {
                    this.instance = editor;
                    this.instance.settings.default_link_target = '_blank';
                    this.instance.settings.link_title = false;
                    this.instance.settings.link_list = this.getLinkList;
                    if (this.textpickerNamespace) {
                        editor.addButton('textpicker', {
                            text: this.$helpers.uiText('R068'),
                            tooltip: this.$helpers.uiText('R068'),
                            icon: false,
                            onclick: () => {
                                this.openTextpicker({
                                    namespace: this.textpickerNamespace,
                                    component: this
                                });
                            }
                        });
                        editor.on('focus', () => {
                            if (this.isTextpickerActive) {
                                this.openTextpicker({
                                    namespace: this.textpickerNamespace,
                                    component: this
                                });
                            }
                        });
                    }
                    this.maxLengthPreventInput(editor);
                    // prevent shift enter (do a normal enter)
                    if (this.slim === true) {
                        editor.on('keydown', function(event) {
                            if (event.keyCode == 13 && event.shiftKey) {
                                event.shiftKey = false;
                            }
                        });
                    }
                    editor.on('focus', () => {
                        this.hasFocus = true;
                    });

                    editor.on('blur', () => {
                        this.hasFocus = false;
                    });
                },
                paste_preprocess: (plugin, args) => {
                    args = this.maxLengthPreventPaste(args);
                    args;
                }
            }
        };
    },
    methods: {
        ...mapActions(['openTextpicker']),
        setTextFromTextpicker(value) {
            // first update content inside wysiwyg
            this.instance.setContent(value);
            // update max length
            this.maxLengthStripAfter(this.instance);
            // then update differ, validation and set property
            this.simpleFieldSet(this.instance.getContent({ format: 'raw' }));
        },
        maxLengthPreventInput(editor) {
            if (this.maxlength) {
                let allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
                editor.on('keydown', (e) => {
                    let length = editor.getContent({ format: 'text' }).length;
                    if (allowedKeys.indexOf(e.keyCode) != -1) {
                        return true;
                    }
                    if (length + 1 > this.maxlength) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    return true;
                });
            }
        },
        maxLengthPreventPaste(args) {
            if (this.maxlength) {
                let length_old = args.target.getContent({ format: 'text' }).length,
                    length_new = args.content.length;
                if (length_old + length_new > this.maxlength) {
                    args.content = args.content
                        .substr(0, this.maxlength - length_old)
                        .replace(/<\/?[^>]+(>|$)/g, ''); // strip html tags
                }
            }
            return args;
        },
        maxLengthStripAfter(editor) {
            if (this.maxlength) {
                if (editor.getContent({ format: 'text' }).length > this.maxlength) {
                    editor.setContent(
                        editor.getContent({ format: 'raw' }).substring(0, this.maxlength),
                        { format: 'raw' }
                    );
                }
            }
        }
    },
    computed: {
        ...mapGetters(['getPages', 'isTextpickerActive']),
        getLinkList() {
            let selectPages = [],
                pages = this.getPages;
            if (pages !== undefined && pages !== null && Object.keys(pages).length > 0) {
                toArray(pages)
                    .sort((a, b) => a.name - b.name)
                    .forEach((pages__value) => {
                        selectPages.push({
                            title: pages__value.name,
                            value: '/editor' + (pages__value.slug === '/' ? '' : pages__value.slug)
                        });
                    });
            }
            return selectPages;
        }
    },
    components: {
        editor: Editor
    },
    mounted() {},
    mixins: [SimpleFieldMixin],
    props: {
        slim: Boolean
    }
};
</script>
